// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__1L12r","input_block":"style_input_block__3_b2y","button":"style_button__3_ha8","buttons":"style_buttons__3kRYA"};